class StatStore {
  constructor(axios) {
    this.axios = axios
    this.state = {}
  }

  getFolders(params) {
    return this.axios.get('stats/folders', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { folders: data })
    })
  }

  getSharedFolders(params) {
    return this.axios.get('stats/shared_folders', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { sharedFolders: data })
    })
  }

  getProducts(params) {
    return this.axios.get('stats/products', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { products: data })
    })
  }

  getDocumentTypes(params) {
    return this.axios.get('stats/document_types', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { documentTypes: data })
    })
  }

  getRecords(params) {
    return this.axios.get('stats/records', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { records: data })
    })
  }

  getContacts(params) {
    return this.axios.get('stats/contacts', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { contacts: data })
    })
  }

  getShareInvites(params) {
    return this.axios.get('stats/share_invites', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { shareInvites: data })
    })
  }

  getChecklistItems(params) {
    return this.axios.get('stats/checklist_items', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { checklistItems: data[0] })
    })
  }

  getSharedChecklistItems(params) {
    return this.axios.get('stats/shared_checklist_items', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { sharedChecklistItems: data[0] })
    })
  }

  getCommunicationMessagesStats(params, global = false) {
    return this.axios.get('stats/record_messages', { params: params }).then(({data}) => {
      if(global)
        this.state = Object.assign({}, this.state, { fileCommunicationStats: data })
      else
        this.state = Object.assign({}, this.state, { recordMessageStats: data })
    })
  }
}

export default StatStore
